import PropTypes from 'prop-types';
import stationPropType from './station';

export default PropTypes.arrayOf(stationPropType);
